export const PAGE_SIZE = 15;

export default PAGE_SIZE;
